import { render, staticRenderFns } from "./EmptyAdminView.vue?vue&type=template&id=6ccf4199&scoped=true&"
import script from "./EmptyAdminView.vue?vue&type=script&lang=js&"
export * from "./EmptyAdminView.vue?vue&type=script&lang=js&"
import style0 from "./EmptyAdminView.vue?vue&type=style&index=0&id=6ccf4199&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf4199",
  null
  
)

export default component.exports